// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"272":"aiembed","594":"about"}[chunkId] + "." + {"272":"76dbe7b3","594":"0f7af5a0"}[chunkId] + ".js";
};